import { useState } from "react";
import { useNavigate } from "react-router";
import "./styles.css";
import api from "../../services/axiosConfig";
import kingsChatWebSdk from "kingschat-web-sdk";
import "kingschat-web-sdk/dist/stylesheets/style.min.css";


export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    church: "",
    zone: "",
    country: "",
    city: "",
    securityQuestion: "",
    securityAnswer: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const SECURITY_QUESTIONS = [
    "What is your mother's maiden name?",
    "What city were you born in?",
    "What was the name of your first pet?",
    "What is your favorite book?",
    "What is the name of the street you grew up on?"
  ];

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (
      !form.name ||
      !form.email ||
      !form.password ||
      !form.church ||
      !form.zone ||
      !form.country ||
      !form.city ||
      !form.securityQuestion ||
      !form.securityAnswer
    ) {
      setError("Please fill in all fields.");
      return;
    }

    setLoading(true);
    try {
      const res = await api.post("/api/auth/register", form);

      // Save token and user details to localStorage
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));

      if (res.data.user && res.data.user.role === "ADMIN") {
        navigate("/admin");
      } else {
        navigate("/profile");
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Registration failed.");
    } finally {
      setLoading(false);
    }
  };

  const handleKingschatSignup = () => {
    setError("");
    setLoading(true);
    const clientId = (
      window.ENV?.KINGSCHAT_CLIENT_ID ||
      process.env.REACT_APP_KINGSCHAT_CLIENT_ID ||
      "5510380c-caac-4baa-ad0c-288dcdffaf1f"
    ).trim();

    const loginOptions = {
      scopes: ["authenticate", "profile"],
      clientId,
    };

    kingsChatWebSdk
      .login(loginOptions)
      .then(async (tokenResponse) => {
        console.log("KingsChat SDK Signup/Login Success:", tokenResponse);
        const { accessToken, user: kcUser } = tokenResponse;

        try {
          const res = await api.post("/api/auth/kingschat", {
            token: accessToken,
            email: kcUser?.email || null,
            firstName:
              kcUser?.first_name ||
              kcUser?.firstName ||
              (kcUser?.name ? kcUser.name.split(" ")[0] : null),
            lastName:
              kcUser?.last_name ||
              kcUser?.lastName ||
              (kcUser?.name && kcUser.name.includes(" ")
                ? kcUser.name.split(" ").slice(1).join(" ")
                : null),
            username: kcUser?.username || null,
          });

          localStorage.setItem("token", res.data.token);
          localStorage.setItem("user", JSON.stringify(res.data.user));

          if (res.data.user?.role === "ADMIN") {
            navigate("/admin");
          } else {
            navigate("/");
          }
        } catch (backendErr) {
          console.error("Backend KingsChat Signup Error:", backendErr);
          const msg =
            backendErr.response?.data?.message ||
            (typeof backendErr.response?.data === "string" ? backendErr.response?.data : null) ||
            backendErr.message ||
            "KingsChat authentication failed on server.";
          setError(msg);
        } finally {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("KingsChat signup error:", err);
        setLoading(false);
        setError("KingsChat signup was cancelled or failed.");
      });
  };

  return (
    <div className="register-page">
      <div className="auth-card" style={{ maxWidth: '600px' }}>
        <div className="auth-logo">
          <span className="logo-icon">✨</span>
          <h2>My Miracle Story</h2>
        </div>
        <h1>Create Account</h1>
        <p className="auth-sub">Join and share what God has done</p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <label>Full Name</label>
            <input
              type="text"
              placeholder="John Doe"
              value={form.name}
              onChange={(e) => set("name", e.target.value)}
              disabled={loading}
            />
          </div>
          
          <div className="auth-field">
            <label>Email</label>
            <input
              type="email"
              placeholder="you@example.com"
              value={form.email}
              onChange={(e) => set("email", e.target.value)}
              disabled={loading}
            />
          </div>
          
          <div className="auth-field">
            <label>Password</label>
            <input
              type="password"
              placeholder="••••••••"
              value={form.password}
              onChange={(e) => set("password", e.target.value)}
              disabled={loading}
            />
          </div>

          <div style={{ display: 'flex', gap: '15px' }}>
            <div className="auth-field" style={{ flex: 1 }}>
              <label>Country</label>
              <input
                type="text"
                placeholder="e.g. India"
                value={form.country}
                onChange={(e) => set("country", e.target.value)}
                disabled={loading}
              />
            </div>
            <div className="auth-field" style={{ flex: 1 }}>
              <label>City</label>
              <input
                type="text"
                placeholder="e.g. Mumbai"
                value={form.city}
                onChange={(e) => set("city", e.target.value)}
                disabled={loading}
              />
            </div>
          </div>
          
          <div style={{ display: 'flex', gap: '15px' }}>
            <div className="auth-field" style={{ flex: 1 }}>
              <label>Zone</label>
              <input
                type="text"
                placeholder="e.g. Zone 4"
                value={form.zone}
                onChange={(e) => set("zone", e.target.value)}
                disabled={loading}
              />
            </div>
            <div className="auth-field" style={{ flex: 1 }}>
              <label>Church</label>
              <input
                type="text"
                placeholder="e.g. Your Church Name"
                value={form.church}
                onChange={(e) => set("church", e.target.value)}
                disabled={loading}
              />
            </div>
          </div>

          <div className="auth-field">
            <label>Security Question (for password reset)</label>
            <select
              value={form.securityQuestion}
              onChange={(e) => set("securityQuestion", e.target.value)}
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '8px',
                backgroundColor: '#161821',
                color: '#ffffff',
                marginBottom: '10px'
              }}
            >
              <option value="">Select a security question</option>
              {SECURITY_QUESTIONS.map((q, i) => (
                <option key={i} value={q}>{q}</option>
              ))}
            </select>
          </div>

          <div className="auth-field">
            <label>Security Answer</label>
            <input
              type="text"
              placeholder="Your answer"
              value={form.securityAnswer}
              onChange={(e) => set("securityAnswer", e.target.value)}
              disabled={loading}
            />
          </div>

          <button type="submit" className="auth-btn" disabled={loading} style={{ marginTop: '10px' }}>
            {loading ? "Processing..." : "Create Account"}
          </button>
        </form>

        <div className="auth-divider" style={{ display: "flex", alignItems: "center", margin: "20px 0", color: "#6e6b7b", fontSize: "13px" }}>
          <div style={{ flex: 1, height: "1px", backgroundColor: "rgba(255,255,255,0.08)" }} />
          <span style={{ padding: "0 14px", textTransform: "uppercase", letterSpacing: "1px" }}>OR</span>
          <div style={{ flex: 1, height: "1px", backgroundColor: "rgba(255,255,255,0.08)" }} />
        </div>

        <button
          type="button"
          onClick={handleKingschatSignup}
          disabled={loading}
          style={{
            width: "100%",
            padding: "14px 20px",
            background: "linear-gradient(135deg, #0084ff 0%, #0066ee 100%)",
            color: "#fff",
            border: "none",
            borderRadius: "12px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: "0 4px 16px rgba(0, 132, 255, 0.3)",
            letterSpacing: "0.5px"
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.477 2 2 6.477 2 12C2 13.82 2.49 15.53 3.35 17L2 22L7.15 20.68C8.58 21.51 10.23 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2Z" fill="#FFFFFF"/>
              <path d="M8.5 7H10.5V11.2L13.8 7H16.3L12.5 11.8L16.5 17H14L10.5 12.3V17H8.5V7Z" fill="#0084FF"/>
            </svg>
            SIGN UP WITH KINGSCHAT
          </span>
          <span style={{ fontSize: "18px" }}>→</span>
        </button>

        <p className="auth-switch">
          Already have an account?{" "}
          <span onClick={() => navigate("/login")}>Sign In</span>
        </p>
      </div>

    </div>
  );
}

